import { FileWarning } from "lucide-react";
import { toast } from "sonner";
import { downloadSkipped } from "@/lib/importJob";
import { errMsg } from "@/lib/api";

/** Shows after an import that rejected rows: one click downloads them (original columns + Error) for correction and re-upload. */
export const SkippedRows = ({ result, name = "import" }) => {
  const n = result?.error_count ?? result?.errors?.length ?? 0;
  if (!result?.job_id || !n) return null;
  return (
    <button type="button" className="inline-flex items-center gap-1 rounded-md border border-rose-300 bg-rose-50 px-3 h-8 text-xs font-semibold text-rose-800 hover:bg-rose-100" onClick={() => downloadSkipped(result.job_id).catch((e) => toast.error(errMsg(e)))} data-testid={`${name}-skipped-download`}>
      <FileWarning size={13} /> Download {n} skipped row{n === 1 ? "" : "s"} (Excel) to fix &amp; re-upload
    </button>
  );
};
